import { render, staticRenderFns } from "./ReferenceImg.vue?vue&type=template&id=47229737&scoped=true"
import script from "./ReferenceImg.vue?vue&type=script&lang=js"
export * from "./ReferenceImg.vue?vue&type=script&lang=js"
import style0 from "./ReferenceImg.vue?vue&type=style&index=0&id=47229737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47229737",
  null
  
)

export default component.exports